import { render, staticRenderFns } from "./full-channel-list.vue?vue&type=template&id=1b26a5df&scoped=true&"
import script from "./full-channel-list.vue?vue&type=script&lang=ts&"
export * from "./full-channel-list.vue?vue&type=script&lang=ts&"
import style0 from "./full-channel-list.vue?vue&type=style&index=0&id=1b26a5df&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b26a5df",
  null
  
)

export default component.exports